import React from 'react'
import './aopsBox.scss'

const AopsBox = ({
  children,
  style,
  title,
  button,
  onButtonClick,
  borderBottom = false,
}) => {
  return (
    <div className="aops-box" style={style}>
      {(title || button) && (
        <div
          className={`aops-box-header ${borderBottom ? 'aops-box-title-with-border' : ''}`}
        >
          {title && <div className="aops-box-title">{title}</div>}
          {button && (
            <button className="aops-box-button" onClick={onButtonClick}>
              {button}
            </button>
          )}
        </div>
      )}
      {children}
    </div>
  )
}

export default AopsBox
